module.exports = __webpack_public_path__ + "static/media/down-green.856d09c7.svg";